module.exports = __webpack_public_path__ + "static/img/img-advantage1.dcfd71b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-advantage1.svg
// module id = YEUs
// module chunks = 0